<template>
  <div>
    <Card :title="$t('common.Trigger')">
      <CardSection>
        <BaseNodeProperties
          :node="node"
          :readonly="readonly"
        />
        <FormLayout>
          <Select
            :label="$t('common.Type')"
            :options="[
              { value: 'SESSION_EXPIRY', label: $t('common.Session Expiry') },
              { value: 'ORDER_RECEIVED', label: $t('common.Order Received') },
              { value: 'EMAIL_COLLECTED', label: $t('common.Email Collected') },
              { value: 'FORM_SUBMISSION', label: $t('common.Form Submission') },
              { value: 'NOTIFICATION_SUBSCRIPTION', label: $t('common.Notification Subscription') },
            ]"
            :disabled="readonly"
            v-model="node.triggerType"
          ></Select>
          <!-- todo triggers
          { value: 'SMS_SUBSCRIBED', label: $t('common.SMS Subscription') },
          { value: 'SMS_RESUBSCRIBED', label: $t('common.SMS Re-Subscription') },
          { value: 'SMS_OTHER', label: $t('common.SMS Other') }, -->
        </FormLayout>
      </CardSection>
    </Card>
  </div>
</template>

<script>
import mixin from './propertiesMixin'

export default {
  mixins: [mixin]
}
</script>
